/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountData } from './AccountData';
import {
    AccountDataFromJSON,
    AccountDataFromJSONTyped,
    AccountDataToJSON,
    AccountDataToJSONTyped,
} from './AccountData';

/**
 *
 * @export
 * @interface ModificationRequest
 */
export interface ModificationRequest {
    /**
     *
     * @type {Array<AccountData>}
     * @memberof ModificationRequest
     */
    create: Array<AccountData>;
    /**
     *
     * @type {Array<AccountData>}
     * @memberof ModificationRequest
     */
    update: Array<AccountData>;
    /**
     *
     * @type {Array<string>}
     * @memberof ModificationRequest
     */
    _delete: Array<string>;
    /**
     *
     * @type {Array<AccountData>}
     * @memberof ModificationRequest
     */
    calculated: Array<AccountData>;
}

/**
 * Check if a given object implements the ModificationRequest interface.
 */
export function instanceOfModificationRequest(value: object): value is ModificationRequest {
    if (!('create' in value) || value['create'] === undefined) return false;
    if (!('update' in value) || value['update'] === undefined) return false;
    if (!('_delete' in value) || value['_delete'] === undefined) return false;
    if (!('calculated' in value) || value['calculated'] === undefined) return false;
    return true;
}

export function ModificationRequestFromJSON(json: any): ModificationRequest {
    return ModificationRequestFromJSONTyped(json, false);
}

export function ModificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModificationRequest {
    if (json == null) {
        return json;
    }
    return {

        'create': ((json['create'] as Array<any>).map(AccountDataFromJSON)),
        'update': ((json['update'] as Array<any>).map(AccountDataFromJSON)),
        '_delete': json['delete'],
        'calculated': ((json['calculated'] as Array<any>).map(AccountDataFromJSON)),
    };
}

export function ModificationRequestToJSON(json: any): ModificationRequest {
    return ModificationRequestToJSONTyped(json, false);
}

export function ModificationRequestToJSONTyped(value?: ModificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'create': ((value['create'] as Array<any>).map(AccountDataToJSON)),
        'update': ((value['update'] as Array<any>).map(AccountDataToJSON)),
        'delete': value['_delete'],
        'calculated': ((value['calculated'] as Array<any>).map(AccountDataToJSON)),
    };
}

